import { isHomePage } from '@/modules/globals'

const SEARCH_BOTTOM_SPACE = 60
const FALLBACK_HEIGHT = 106
const FALLBACK_OBSERVER_TARGET = document.getElementById('stage') 

export default {
  data () {
    return {
      sticky: false,
    }
  },

  computed: {
    headerComponentHeight () {
      return document.querySelector('.header').clientHeight
    },

    componentHeight () {
      return this.$root.$el.clientHeight || FALLBACK_HEIGHT
    },

    rootTopMargin () {
      return isHomePage() ? this.homePageStickyRootMargin : this.componentHeight
    },

    homePageStickyRootMargin () {
      return this.headerComponentHeight + this.componentHeight + SEARCH_BOTTOM_SPACE
    },

    observerTarget () {
      return this.$root.$el.offsetParent || FALLBACK_OBSERVER_TARGET
    },
    
    rootMargin () {
      return `-${this.rootTopMargin}px 0px 0px 0px`
    },
  },

  methods: {
    setComponentAsSticky () {
      const observer = new IntersectionObserver(this.updateRootPosition, {
        root: null,
        rootMargin: this.rootMargin,
        threshold: 0,
      })

      observer.observe(this.observerTarget)
    },

    setStickyPosition () {
      this.sticky = true
    },

    unsetStickyPosition () {
      this.sticky = false
    },

    updateRootPosition (entries) {
      entries.forEach(entry => { 
        if (entry.isIntersecting) this.unsetStickyPosition() 
        else this.setStickyPosition() 
      })
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/search/StickySearchMixin.js